export enum NpsSurveyType {
    ScoreOnly = 'ScoreOnly',
    WithQuestions = 'WithQuestions',
}

export enum NpsSurveyAnswerValue {
    StronglyDisagree = 'StronglyDisagree',
    Disagree = 'Disagree',
    Neutral = 'Neutral',
    Agree = 'Agree',
    StronglyAgree = 'StronglyAgree',
}
